import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    allowedWidgetKinds: [['teaser-toi-commercial']],
  }) as const) satisfies ConfigFn

export default config
